import { ApiClient } from '../../../api/ApiClient';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Communicator } from '../../../concepts/objects';
import { KeyInput } from '../../../platform/input/KeyInput';
import { Keys } from '../../../platform/input/Keys';
import { MouseInput } from '../../../platform/input/MouseInput';
import { resolve } from '../../Container';
import { Camera } from '../Camera';
import { ConfettiCannon } from '../ConfettiCannon';
import { Telemetry } from '../Telemetry';
import { Physical } from '../entities/Physical';
import { EffectDirector, Effects } from '../visualization/EffectDirector';
import { ToolBehavior } from './ToolBehavior';
import { ToolOverlay } from './ToolOverlay';

export class ShowObjectToolBehavior extends ToolBehavior {

    @resolve(ApiClient) private api!: ApiClient;
    @resolve(Camera) private camera!: Camera;
    @resolve(Communicator) private comms!: Communicator;
    @resolve(ConfettiCannon) private cannon!: ConfettiCannon;
    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ToolOverlay) private overlay!: ToolOverlay;
    @resolve(Telemetry) private telemetry!: Telemetry;
    @resolve(EffectDirector) private effects!: EffectDirector;

    private active = null as Physical;

    public init() {
    }

    public onKeyDown(state: string, e: KeyInput): string | void {
        if (state === 'idle' && e.key === Keys.KEY_Q) {
            return 'showing';
        }
    }

    public onMouseMove(state: string, e: MouseInput): string | void {
        if (state === 'showing') {
            this.show(e.targetPhysical);
        }
    }

    public onKeyUp(state: string, e: KeyInput): string | void {
        if (state === 'showing' && e.key === Keys.KEY_Q) {
            this.unshow();
            return 'idle';
        }
    }

    private show(phys: Physical) {
        this.unshow();
        this.active = phys;
        this.effects.trigger(Effects.raise(4), phys);
    }

    private unshow() {
        if (this.active) {
            this.effects.untrigger('raise', this.active);
            this.active = null;
        }
    }
}
